import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import { InputBase, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useTranslation } from 'react-i18next'

const options = [
    { value: 'ooOffice', label: 'OoO' },
    { value: 'inOffice', label: 'InOffice' },
]

const StyledInput = styled(InputBase)(({ theme }) => ({
    '&.MuiInputBase-root': {
        marginTop: '3rem',
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    '& .MuiInputBase-input': {
        boxShadow: '0 0.2rem 0.8rem 0 rgba(0, 0, 0, 0.1)',
        border: 'solid 1px #d8d8dd',
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        fontSize: 16,
        padding: '0.6rem 0.8rem 0.6rem 1.2rem',
        minWidth: '12rem !important',
        minHeight: '0 !important',
        lineHeight: '1.2',
        color: '#3b454d',

        '&:focus': {
            borderRadius: 4,
            borderColor: 'transparent',
            boxShadow: '0 0 0 0.3rem rgba(0,123,255,.25)',
        },
    },
}))

export const OutOfOffceSelector = (props: any) => {
    const { t } = useTranslation()

    const { handleChange, value }: any = props

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false)
    }

    const handleOpen = () => {
        setOpen(true)
    }

    const onChange = (event: SelectChangeEvent<string>) => {
        handleChange(event.target.value)
    }

    const menuProps: any = {
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        },
        getContentAnchorEl: null,
    }

    return (
        <>
            <Select
                variant="standard"
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                value={value}
                onChange={onChange}
                inputProps={{ 'aria-label': 'Out of office' }}
                MenuProps={{
                    ...menuProps,
                }}
                input={<StyledInput />}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {t(option.label)}
                    </MenuItem>
                ))}
            </Select>
        </>
    )
}
